import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/GetZois'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class GetZoisStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "GetZoisStore",
			variables: true,
		})
	}
}

export async function load_GetZois(params) {
  await initClient()

	const store = new GetZoisStore()

	await store.fetch(params)

	return {
		GetZois: store,
	}
}
